import { Flex, Group, Icon, notification, PopOver, Text } from "components/common"
import { Divider, Space } from "antd"
import { localisedValue } from "utils"
import dayjs from "dayjs"
import { DateFormat } from "components/common"
import { useLazyGetFlaggedLeadDetailsQuery } from "features/shared/api"
import { useState, useMemo, useEffect } from "react"
import { t } from "i18next"
import theme from "utils/themeVars"
import { CLIENT_DETAIL_PATH } from "constants/app-paths"
import { Link } from "react-router-dom"
import { useGetLeadCategoriesQuery } from "../../../clients/detail/api"

const showRedirectIcon = {
  audit_concerns: true,
}
const FlaggedLeads = ({ lead, redirectToClientReviews = false }) => {
  const { data: leadCategoriesData } = useGetLeadCategoriesQuery({ flagVisibility: true })
  const [fetchFlaggedLeadDetails, { data: flaggedLeadData, isFetching: isFetchingFlaggedLead }] =
    useLazyGetFlaggedLeadDetailsQuery()

  const [activeFlagId, setActiveFlagId] = useState(null)
  const [visibleFlags, setVisibleFlags] = useState([])

  useEffect(() => {
    if (lead?.flagIds && leadCategoriesData?.flagColorIdMap) {
      const filteredFlags = lead.flagIds.filter(id => id in leadCategoriesData.flagColorIdMap)
      setVisibleFlags(filteredFlags)
    }
  }, [lead?.flagIds, leadCategoriesData?.flagColorIdMap])

  const getContentForFlaggedLead = (flaggedLeadData, lead, redirectToClientReviews) => {
    return (
      flaggedLeadData && (
        <div>
          <Group style={{ padding: "12px" }} gap="8px" template="initial">
            <Flex gap="6px" align="center" justify="space-between">
              <Space gap="6px" align="center">
                <Icon
                  hasBackground
                  style={{ padding: 3 }}
                  iconContainerStyle={{ translate: "0px 2px", padding: 0 }}
                  className="pointer"
                  icon={flaggedLeadData?.icon}
                  size="18px"
                  color={flaggedLeadData?.flagColor}
                />
                <strong>{localisedValue({ object: flaggedLeadData?.InternalInquiryCategory, key: "title" })}</strong>
              </Space>
            </Flex>

            <Text type={"secondary"} className="fs12">
              {localisedValue({ object: flaggedLeadData?.InternalInquiryCategory, key: "formattedTooltip" })}{" "}
            </Text>
          </Group>
          <Divider style={{ marginBlock: "0px" }} />
          <div style={{ background: flaggedLeadData?.bgColor, padding: "12px" }}>
            <Flex vertical align="start">
              {redirectToClientReviews && showRedirectIcon[flaggedLeadData?.InternalInquiryCategory?.key] ? (
                <Flex gap="6px" align="center" justify="space-between">
                  <Text className="fs12 semiBold">{t("Detailed Review")}</Text>
                  <Link
                    className="text-link mbe-4"
                    to={CLIENT_DETAIL_PATH.replace(":clientId", lead?.clientId) + `?activeTab=leadReviews`}
                  >
                    <Icon icon="FiExternalLink" size="12px" />
                  </Link>
                </Flex>
              ) : (
                <>
                  <Text className="fs14 semiBold">{t("Required Action")}</Text>
                  <Text type={"secondary"} className="fs12">
                    {localisedValue({ object: flaggedLeadData?.InternalInquiryCategory, key: "actionRequired" })}{" "}
                  </Text>
                </>
              )}
            </Flex>
          </div>
        </div>
      )
    )
  }

  const onFlagClick = (e, flag) => {
    e.stopPropagation()
    setActiveFlagId(flag)
    fetchFlaggedLeadDetails({ inquiryId: lead?.id, categoryId: flag }, true)
      .unwrap()
      .then(responseData => {
        if (responseData) {
          setActiveFlagId(flag)
        } else {
          setActiveFlagId(flag)
        }
      })
      .catch(e => {
        notification?.error({ message: e?.message })
        setActiveFlagId(null)
      })
  }
  return (
    <Space size={2}>
      {visibleFlags?.map(flag => (
        <PopOver
          trigger="click"
          visible={activeFlagId === flag && !isFetchingFlaggedLead}
          onVisibleChange={visible => {
            if (!visible) setActiveFlagId(null)
          }}
          content={getContentForFlaggedLead(flaggedLeadData, lead, redirectToClientReviews)}
          overlayInnerStyle={{ width: 350, borderRadius: "10px", padding: "0px" }}
        >
          <Icon
            hasBackground
            icon={leadCategoriesData?.flagColorIdMap?.[flag]?.icon}
            color={leadCategoriesData?.flagColorIdMap?.[flag]?.flagColor}
            size="18px"
            style={{ padding: 3 }}
            iconContainerStyle={{ translate: "0px 2px", padding: 0 }}
            className="pointer"
            isLoading={activeFlagId === flag && isFetchingFlaggedLead}
            onClick={e => onFlagClick(e, flag)}
          />
        </PopOver>
      ))}
    </Space>
  )
}
export default FlaggedLeads
